import request from '@/utils/request'
export const supSave = (data) => {
    return request({
        url: '/proApply/supSave',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const eightBitCode = (data) => {
    return request({
        url: '/proApply/eightBitCode',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    });
}
export const quotationInit = (data) => {
    return request({
        url: '/productQuote/init',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const updateQuotationPro = (data) => {
    return request({
        url: '/productQuote/save',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
export const quotationHistoryInit = (data) => {
    return request({
        url: '/productQuote/history',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}

export const calcProductPrice = (data) => {
    return request({
        url: '/productQuote/calc',
        method: 'post',
        headers: {
            'Content-Type': 'application/json; charset=UTF-8'
        },
        data: data
    })
}
